<template>
    <div>
        <el-menu
            :default-active="sss"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <router-link to="/">
            <el-menu-item index="1">出差申请</el-menu-item>
            </router-link>
            <router-link to="/tripReimbursement">
            <el-menu-item index="2">差旅报销</el-menu-item>
            </router-link>
            <!-- <router-link to="/">
            <el-menu-item index="1">
            <el-input v-model="input" @keyup.enter.native="enter" placeholder="请输入您的邮箱" autofocus="autofocus"></el-input>
            <i class="el-icon-search" @click="clickMe"></i>
            </el-menu-item>
            </router-link> -->
        </el-menu>
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: "",
            iptValue: "",
            list: [],
            sss: this.$route.name
        };
    },
    created() {
        // console.log(this.input);
    },
    mounted() {
        // console.log(this.input);
    },
    methods: {
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
        },
        clickMe() {
            // console.log(this.input);
            // localStorage.clear();
            this.iptValue = localStorage.value;
            localStorage.setItem("value", this.input);
            // console.log(localStorage);
            window.location.reload();
        },
        enter() {
            if (event.keyCode == 13) {
                this.iptValue = localStorage.value;
                localStorage.setItem("value", this.input);
                // console.log(localStorage);
                window.location.reload();
            }
        }
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/nav.vue